"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var isDevelopment = typeof process !== 'undefined' && typeof process.env !== 'undefined' && (!process.env.NODE_ENV || process.env.NODE_ENV === 'development');
exports.default = isDevelopment;